import { render, staticRenderFns } from "./SHTakeoutCardSkeleton.vue?vue&type=template&id=2090b30b&"
import script from "./SHTakeoutCardSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SHTakeoutCardSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports